import { render, staticRenderFns } from "./StatisticOverview.vue?vue&type=template&id=0be8b3f3&scoped=true"
import script from "./StatisticOverview.vue?vue&type=script&lang=js"
export * from "./StatisticOverview.vue?vue&type=script&lang=js"
import style0 from "./StatisticOverview.vue?vue&type=style&index=0&id=0be8b3f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be8b3f3",
  null
  
)

export default component.exports